"use client";

import React, { useMemo } from "react";

import useCheckUS from "@/hooks/data/useCheckUS";
import { usePersistState } from "@/hooks/usePersistState";
import { SupAlertBar, SupText } from "@repo/core-ui";
import { SupLock } from "@repo/core-ui";

export default function LayoutAlertBarUsRestriction() {
  const { restricted, isLoading } = useCheckUS();
  const [displayMessage, setDisplayMessage] = usePersistState<boolean>(`us-bar-restriction-seen`, true);

  const isVisible = useMemo(() => !!restricted && !isLoading && displayMessage, [displayMessage, isLoading, restricted]);

  return (
    <SupAlertBar
      visible={isVisible}
      closeable
      onClose={() => setDisplayMessage(false)}
      content={
        <SupText variant="caption" weight="bold">
          Transacting on this interface is not available to residents of the United States and its territories (Puerto Rico, Guam, American Samoa, U.S. Virgin Islands and the
          Mariana Islands). Please see our&nbsp;
          <a href="https://superformlabs.org/terms-of-service" target="_blank" className="underline hover:no-underline">
            Terms of Service
          </a>
          &nbsp;for more information.
        </SupText>
      }
      icon={<SupLock />}
      color="warning"
    />
  );
}
